<template>
  <footer class="site-footer">
    <div class="footer-primary">
      <div class="container footer-grid">
        
        <!-- 第一列：品牌与二维码 -->
        <div class="footer-column footer-brand">
          <h3 class="brand-title">辽宁资产管理有限公司</h3>
          <p class="brand-en">Liaoning Asset Management Co.,Ltd</p>
          <p class="brand-motto">专业、稳健、创新、共赢</p>
          <div class="qr-codes">
            <div class="qr-item">
              <img :src="$store.state.siteConfig.showWeixin" alt="微信公众号" class="qr-img" />
              <span>微信公众号</span>
            </div>
            <div class="qr-item">
              <img :src="$store.state.siteConfig.showMiniapp" alt="推介平台小程序" class="qr-img" />
              <span>推介平台小程序</span>
            </div>
          </div>
        </div>

        <!-- 第二列：联系方式 -->
        <div class="footer-column footer-contact">
          <h4>联系方式</h4>
          <ul>
            <li>
              <i class="el-icon-location-outline"></i>
              <span>{{ $store.state.siteConfig.showAddress }}</span>
            </li>
            <li>
              <i class="el-icon-phone"></i>
              <span>{{ $store.state.siteConfig.showPhone }}</span>
            </li>
            <li v-if="$store.state.siteConfig.showFax">
              <i class="el-icon-printer"></i>
              <span>{{ $store.state.siteConfig.showFax }}</span>
            </li>
            <li>
              <i class="el-icon-message"></i>
              <span>{{ $store.state.siteConfig.showEmail}}</span>
            </li>
          </ul>
        </div>

        <!-- 第三列：快速链接 -->
        <div class="footer-column footer-links1">
          <h4>网站地图</h4>
          <ul>
            <li><router-link to="/home">首页</router-link></li>
            <li v-for="menu in menuList" :key="menu.id">
              <a v-if="menu.isExternal" :href="menu.path" target="_blank">{{ menu.menuName }}</a>
              <router-link v-else :to="{ path: menu.path, query: { id: menu.scode } }">{{ menu.menuName }}</router-link>
            </li>
          </ul>
        </div>

        <!-- 第四列：友情链接 -->
        <div class="footer-column footer-friends">
          <h4>友情链接</h4>
          <ul class="friend-links-grid">
            <li v-for="(item, index) in friendLinks" :key="index">
              <a :href="item.targetUrl" target="_blank">{{ item.name }}</a>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- 底部版权栏 -->
    <div class="footer-bottom">
      <div class="container bottom-content">
        <p class="copyright">{{ $store.state.siteConfig.showFooter }}</p>
        <div class="copyright-links">
          <span>{{ $store.state.siteConfig.showRecord }}</span>
          <span class="divider">|</span>
          <span>{{ $store.state.siteConfig.showTemplate }}</span>
<!--          <span class="divider">|</span>-->
<!--          <a href="#" @click.prevent="showDialog('yszc')">隐私政策</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a href="#" @click.prevent="showDialog('flsm')">法律声明</a>-->
        </div>
      </div>
    </div>

    <!-- 隐私政策与法律声明弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      class="policy-dialog"
      append-to-body
    >
      <div class="policy-content" v-html="dialogContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </footer>
</template>

<script>
import { getLabelList, getAyLinkList } from '@/api/menu'

export default {
  name: 'Footer',
  data() {
    return {
      yszc: '',
      flsm: '',
      friendLinks: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogContent: ''
    }
  },
  computed: {
    menuList() {
      return this.$store.state.menuList || []
    }
  },
  created() {
    this.fetchFriendLinks();
  },
  methods: {
    async showDialog(name) {
      try {
        const res = await getLabelList({ name })
        if (res.code === 0 && res.data) {
          this.dialogVisible = true;
          if (name === 'yszc') {
            this.dialogTitle = '隐私政策';
            this.dialogContent = res.data.value;
          }  else if (name === 'flsm') {
            this.dialogTitle = '法律声明';
            this.dialogContent = res.data.value;
          }
        }
      } catch (error) {
        console.error(`获取${name}失败:`, error)
      }
    },
    async fetchFriendLinks() {
      try {
        const res = await getAyLinkList();
        if (res.code === 0 || res.code === 200) {
          this.friendLinks = res.data || res.rows || [];
        }
      } catch (error) {
        console.warn('获取友情链接字典失败，将使用默认链接:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$dark-bg: #1a1a2e;
$mid-bg: #1a1a2e;
$text-light: #ffffff;
$text-gray: #a0aab5;
$accent-red: #c0392b;

.site-footer {
  background-color: $dark-bg;
  color: $text-gray;
  font-family: 'Microsoft YaHei', sans-serif;
  font-size: 14px;
}

.footer-primary {
  background-color: $mid-bg;
  padding: 40px 0 40px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.2fr 1.2fr 1fr 2.0fr;
  gap: 40px;
  align-items: flex-start;
}

.footer-column {
  h4 {
    color: $text-light;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;
    
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 30px;
      height: 2px;
      background-color: $accent-red; // 配合主格调
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 12px;
      display: flex;
      align-items: flex-start;
      gap: 8px;
      line-height: 1.6;

      i {
        margin-top: 4px;
        color: $accent-red;
      }

      a {
        color: $text-gray;
        text-decoration: none;
        transition: color 0.2s;
        
        &:hover {
          color: $text-light;
        }
      }
    }
  }
}

/* 第一列：品牌与二维码 */
.footer-brand {
  .brand-title {
    color: $text-light;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .brand-en {
    font-size: 11px;
    color: #8392a5;
    margin-bottom: 12px;
  }
  .brand-motto {
    font-size: 13px;
    color: #8392a5;
    margin-bottom: 20px;
    letter-spacing: 1px;
  }

  .qr-codes {
    display: flex;
    gap: 20px;

    .qr-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      font-size: 12px;
      color: #8392a5;

      .qr-img {
        width: 90px;
        height: 90px;
        background: #fff;
        padding: 5px;
        border-radius: 4px;
      }
    }
  }
}

/* 第四列：友情链接多列网格 */
.friend-links-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 20px;
}

/* 底部版权栏 */
.footer-bottom {
  background-color: $dark-bg;
  padding: 20px 0;
  font-size: 12px;
  border-top: 1px solid #242a35;

  .bottom-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }

  .copyright {
    margin: 0;
    color: #8392a5;
  }

  .copyright-links {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #8392a5;

    .divider {
      color: #384353;
    }

    a {
      color: #8392a5;
      text-decoration: none;
      &:hover {
        color: $text-light;
      }
    }

    i {
      margin-right: 3px;
    }
  }
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  .footer-brand .qr-codes {
    justify-content: flex-start;
  }
  .footer-column ul li a {
    display: inline-block;
    padding: 6px 0; /* 增加移动端链接触摸面积 */
  }
  .friend-links-grid {
    grid-template-columns: 1fr; /* 友情链接单列 */
  }
  .footer-bottom .bottom-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .copyright-links {
    flex-wrap: wrap;
    justify-content: center;
    line-height: 2;
    margin-top: 10px;
  }
}

::v-deep .policy-dialog {
  .el-dialog {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    background: #fff;
    
    .el-dialog__header {
      padding: 20px 25px;
      border-bottom: 1px solid #f0f0f0;
      background: #fcfcfc;
      
      .el-dialog__title {
        font-weight: 600;
        color: #1a1a1a;
        font-size: 18px;
      }
    }
    
    .el-dialog__body {
      padding: 30px 25px;
      max-height: 65vh;
      overflow-y: auto;
      color: #4a4a4a;
      line-height: 1.8;
      font-size: 15px;

      // 滚动条美化
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      p {
        margin-bottom: 16px;
      }
      
      h3, h4 {
        color: #2c3e50;
        margin: 24px 0 12px;
        font-weight: 600;
      }
    }

    .footer-column.footer-links1 {
      transform: none !important; /* 强制清空外部注入的偏移 */
    }
    .footer-links:not(.friend-links) {
    
}
    
    .el-dialog__footer {
      padding: 16px 25px 24px;
      border-top: 1px solid #f0f0f0;
      text-align: right;
      
      .el-button--primary {
        background: linear-gradient(135deg, $accent-red, darken($accent-red, 10%));
        border: none;
        padding: 12px 36px;
        font-weight: 500;
        border-radius: 6px;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba($accent-red, 0.3);
          background: linear-gradient(135deg, lighten($accent-red, 5%), $accent-red);
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}
</style>
